import { faqData } from '@/mocks/homepage';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            关于番茄漫画，你想知道的都在这里
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl p-5 md:p-6"
            >
              <h3 className="font-medium text-sm md:text-base text-foreground-900 mb-2 flex items-start gap-3">
                <span className="text-primary-500 font-heading text-lg flex-shrink-0 leading-tight">
                  Q
                </span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-8">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}